// extracted by mini-css-extract-plugin
export var attribution = "_av-4";
export var authorName = "_av-5";
export var quote = "_av-3";
export var testimonial = "_av-2";
export var trustedBy = "_av-0";
export var trustedByLabel = "_av-1";